import CardImage from '@crm/components/card-image/card-image';
import Typography from '@crm/components/typography';
import HorizontalSpacing from '../horizontal-spacing';
import {SlideElement} from './cards-scroll-section';
import {ReactElement} from "react";

interface Props {
    title: string | ReactElement;
    elements: SlideElement[];
}

export const SixGridMiddlePt = (props: Props) => {
    const {title, elements} = props;
    const spaceBetween = 15;

    return <div>
        <HorizontalSpacing>
            <Typography variant="h2" className="text-center py-[80px]">
                {title}
            </Typography>
            <div className="grid grid-cols-3 gap-1 pb-[80px]">
                <div className="w-full flex justify-center">
                    <div>
                        <CardImage
                            imageSrc={elements[0].imageSrc}
                            imageAlt={elements[0].imageAlt}
                            title={elements[0].title}
                            text={elements[0].text}
                            textClassName="w-[80%]"
                            spaceBetween={spaceBetween}
                        />
                    </div>
                </div>
                <div className="w-full flex justify-center pt-20">
                    <div>
                        <CardImage
                            imageSrc={elements[1].imageSrc}
                            imageAlt={elements[1].imageAlt}
                            title={elements[1].title}
                            text={elements[1].text}
                            textClassName="w-[80%]"
                            spaceBetween={spaceBetween}
                        />
                    </div>
                </div>
                <div className="w-full flex justify-center">
                    <div>
                        <CardImage
                            imageSrc={elements[2].imageSrc}
                            imageAlt={elements[2].imageAlt}
                            title={elements[2].title}
                            text={elements[2].text}
                            textClassName="w-[80%]"
                            spaceBetween={spaceBetween}
                        />
                    </div>
                </div>
                <div className="w-full flex justify-center">
                    <div>
                        <CardImage
                            imageSrc={elements[3].imageSrc}
                            imageAlt={elements[3].imageAlt}
                            title={elements[3].title}
                            text={elements[3].text}
                            textClassName="w-[80%]"
                            spaceBetween={spaceBetween}
                        />
                    </div>
                </div>
                <div className=" w-full flex justify-center pt-20">
                    <div>
                        <CardImage
                            imageSrc={elements[4].imageSrc}
                            imageAlt={elements[4].imageAlt}
                            title={elements[4].title}
                            text={elements[4].text}
                            textClassName="w-[80%]"
                            spaceBetween={spaceBetween}
                        />
                    </div>
                </div>
                <div className=" w-full flex justify-center">
                    <div>
                        <CardImage
                            imageSrc={elements[5].imageSrc}
                            imageAlt={elements[5].imageAlt}
                            title={elements[5].title}
                            text={elements[5].text}
                            textClassName="w-[80%]"
                            spaceBetween={spaceBetween}
                        />
                    </div>
                </div>
            </div>
        </HorizontalSpacing>
    </div>;
};
